<template>
    <div>
        <svg :width="iconSize" :height="iconSize" viewBox="0 0 19 22" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M15.3264 1.96084C16.4728 2.09389 17.3125 3.08229 17.3125 4.23644V20.375L9.5 16.4688L1.6875 20.375V4.23644C1.6875 3.08229 2.52717 2.09389 3.67363 1.96084C5.58496 1.73903 7.52916 1.625 9.5 1.625C11.4708 1.625 13.415 1.73903 15.3264 1.96084Z"
                :stroke="color" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
        </svg>
    </div>
</template>

<script>
export default {
    name: 'IconSvgBookmarkEmpty',
    props: {
        color: {
            type: String,
            default: '#000000',
        },
        size: {
            type: Number,
            default: null
        }
    },
    computed: {
        iconSize() {
            return this.size ? `${this.size}px` : '44px'
        }
    }
};
</script>

<style scoped></style>